import {Mental2SymbolStates, XHOLE_STATE} from "../enums/Enum";
import {Symbol} from "./Symbol";
import {GameUtils} from "../utils/GameUtils";
import {gsap} from "gsap";
import TrackEntry = PIXI.spine.core.TrackEntry;

export class XHoleSymbol extends Symbol {
    private _superState: XHOLE_STATE = XHOLE_STATE.NONE;

    constructor(symbolName: string, initState: Mental2SymbolStates, index: number, isActive: boolean = false) {
        super(symbolName, initState, index);
    }

    clearAnimations() {
        this._superState = XHOLE_STATE.NONE;
        super.clearAnimations();
    }

    public playAnticipation(): void {
        this.autoUpdate = true;
        const animNameArr: string[] = (this.state.tracks[0].animation.name).split("_");
        const animName: string = animNameArr[animNameArr.length - 1];
        this.state.setAnimation(0, animName + "_anticipation", true);
        this._superState = XHOLE_STATE.ANTICIPATION;
    }

    public stopAnticipation(): void {
        this.autoUpdate = true;
        const animName: string = this.state.tracks[0].animation.name;
        this.state.setAnimation(0, animName, false);
        this._superState = XHOLE_STATE.NONE;
    }

    public playNoWin(): gsap.core.Timeline {
        this.autoUpdate = true;
        const animNameArr: string[] = (this.state.tracks[0].animation.name).split("_");
        const animName: string = animNameArr[animNameArr.length - 1];
        this._superState = XHOLE_STATE.NO_WIN;
        return GameUtils.createTimelineForAnimation(this, 0, animName + "_NoWin", false);
    }

    setState(state: Mental2SymbolStates): PIXI.spine.core.TrackEntry | undefined {
        return super.setState(state);
    }

    public setResizeState(animName: string): TrackEntry {
        this.autoUpdate = true;
        if (this._superState === XHOLE_STATE.ANTICIPATION) {
            const animNameArr: string[] = animName.split("_");
            const animNameStr: string = animNameArr[animNameArr.length - 1];
            return this.state.setAnimation(0, animNameStr + "_anticipation", true);
        } else if (this._superState === XHOLE_STATE.NO_WIN) {
            const animNameArr: string[] = animName.split("_");
            const animNameStr: string = animNameArr[animNameArr.length - 1];
            animName = animNameStr + "_NoWin"
        }
        return super.setResizeState(animName);
    }
}